import React, { Component } from 'react'
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryGroup,
  VictoryLegend,
  VictoryTheme,
} from 'victory'

class AssessmentComparisonGraph extends Component {
  normalizeAssessment = (
    score,
    minimum,
    maximum
  ) => {
    if (
      score === null ||
      score === undefined
    ) {
      return null
    }

    const percentage =
      ((score - minimum) /
        (maximum - minimum)) *
      100

    return Math.max(
      2,
      Math.min(100, percentage)
    )
  }

  getAssessmentGraphData = () => {
    const assessments = [
      {
        assessment: 'Depression',
        baseline: 21,
        previous: 17,
        latest: 18,
        minimum: 0,
        maximum: 27,
      },
      {
        assessment: 'Mania',
        baseline: 11,
        previous: 12,
        latest: 13,
        minimum: 0,
        maximum: 20,
      },
      {
        assessment: 'Anxiety',
        baseline: 21,
        previous: 17,
        latest: 17,
        minimum: 0,
        maximum: 21,
      },
      {
        assessment: 'Sleep',
        baseline: 16,
        previous: 21,
        latest: 20,
        minimum: 0,
        maximum: 21,
      },
      {
        assessment: 'Well-being',
        baseline: null,
        previous: 5,
        latest: 4,
        minimum: 0,
        maximum: 25,
      },
      /*{
        assessment: 'PWS/PW18',
        baseline: 44,
        previous: 68,
        latest: 52,
        minimum: 18,
        maximum: 126,
      },
      {
        assessment: 'DERS-18',
        baseline: 78,
        previous: 75,
        latest: 64,
        minimum: 18,
        maximum: 90,
      },*/
    ]

    const createGraphData = scoreKey =>
      assessments.map(item => ({
        x: item.assessment,
        y: this.normalizeAssessment(
          item[scoreKey],
          item.minimum,
          item.maximum
        ),
        score: item[scoreKey],
      }))

    return {
      assessments,
      baselineData:
        createGraphData('baseline'),
      previousData:
        createGraphData('previous'),
      latestData:
        createGraphData('latest'),
    }
  }

  render() {
    const assessmentGraph =
      this.getAssessmentGraphData()

    const allValues = [
      ...assessmentGraph.baselineData,
      ...assessmentGraph.previousData,
      ...assessmentGraph.latestData,
    ]
      .map(item => item.y)
      .filter(
        value =>
          value !== null &&
          value !== undefined
      )

    const highestValue =
      allValues.length > 0
        ? Math.max(...allValues)
        : 100

    const graphMaximum = Math.min(
      105,
      Math.ceil(
        (highestValue * 1.05) / 5
      ) * 5
    )

    const chartWidth = 450

    return (
      <div className="small-12 columns">
        <div className="title6">
          Assessment Score Comparison Chart
        </div>

        <VictoryChart
          width={chartWidth}
          height={150}
          theme={VictoryTheme.material}
          domain={{
            y: [0, graphMaximum],
          }}
          domainPadding={{
            x: 40,
          }}
          padding={{
            top: 35,
            bottom: 38,
            left: 20,
            right: 20,
          }}
        >
          <VictoryLegend
            x={(chartWidth - 245) / 3}
            y={10}
            orientation="horizontal"
            gutter={18}
            style={{
              labels: {
                fontSize: 8,
              },
            }}
            data={[
              {
                name: 'At Enrollment',
                symbol: {
                  fill: '#7e57c2',
                },
              },
              {
                name: 'Previous',
                symbol: {
                  fill: '#fb8c00',
                },
              },
              {
                name: 'Now',
                symbol: {
                  fill: '#1e88e5',
                },
              },
            ]}
          />

          <VictoryAxis
            tickValues={assessmentGraph.assessments.map(
              item => item.assessment
            )}
            style={{
              tickLabels: {
                fontSize: 7,
                angle: -45,
                textAnchor: 'end',
                padding: 2,
              },
            }}
          />

          <VictoryAxis
            dependentAxis
            tickFormat={() => ''}
            style={{
              tickLabels: {
                display: 'none',
              },
            }}
          />

          <VictoryGroup
            offset={9}
            colorScale={[
              '#7e57c2',
              '#fb8c00',
              '#1e88e5',
            ]}
          >
            <VictoryBar
              data={
                assessmentGraph.baselineData
              }
              barWidth={7}
            />

            <VictoryBar
              data={
                assessmentGraph.previousData
              }
              barWidth={7}
            />

            <VictoryBar
              data={
                assessmentGraph.latestData
              }
              barWidth={7}
            />
          </VictoryGroup>
        </VictoryChart>
      </div>
    )
  }
}

export default AssessmentComparisonGraph
